<template>
  <footer id="footer" class="bg-light footer-light">
    <div class="container container-1000">
      <div class="row">
        <div class="col-lg-3">
          <router-link to="/">
            <img :src="require('../assets/img/ninkashi_logo.png')" width="150" height="150" />
          </router-link>
        </div>

        <div class="col-lg-3 col-sm-6">
          <div class="footer-links">

          </div>
        </div>

        <div class="col-lg-3 col-sm-6">
          <div class="footer-links">

          </div>
        </div>

        <div class="col-lg-3 col-sm-6">
          <div class="footer-links">

          </div>
        </div>
      </div>

      <div class="footer-credits d-lg-flex justify-content-lg-between align-items-center">
        <div>
          Copyright © {{ moment().year() }} - Ninkashi.com
          <br/>

          <a href="javascript:;" @click="$bvModal.show('termsOfUseAndPrivacy')"
            style="color: #007bff;">
            Terms of Use and Privacy Policy
          </a>
        </div>
      </div>
    </div>

    <TermsOfUseAndPrivacy />
  </footer>
</template>

<script>
import TermsOfUseAndPrivacy from '../components/common/TermsOfUseAndPrivacy'

export default {
  name: 'LayoutFooter',
  components: {
    TermsOfUseAndPrivacy
  },
  data: function () {
    return { }
  }
}
</script>
